var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _TextPropTypes=require('../../propTypes/TextPropTypes');var _TextPropTypes2=_interopRequireDefault(_TextPropTypes);
var _ViewStylePropTypes=require('../View/ViewStylePropTypes');var _ViewStylePropTypes2=_interopRequireDefault(_ViewStylePropTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

module.exports=_extends({},_ViewStylePropTypes2.default,_TextPropTypes2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/components/Text/TextStylePropTypes.js
 ** module id = 281
 ** module chunks = 0
 **/